import { render } from "./UnsubscribePage.vue?vue&type=template&id=66a7d536&scoped=true"
import script from "./UnsubscribePage.vue?vue&type=script&lang=js"
export * from "./UnsubscribePage.vue?vue&type=script&lang=js"

import "./UnsubscribePage.vue?vue&type=style&index=0&id=66a7d536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a7d536"]])

export default __exports__